<template>
  <section v-if="isGetRequestPending" class="edit-message">
    <p-loading />
  </section>
  <section v-else class="edit-message">
    <header>
      <h1>Edit Message</h1>
      <div class="action-wrapper">
        <p-button v-if="$hasPermission('messages')" color="secondary" @click="confirmDelete">Delete</p-button>
      </div>
    </header>
    <p-edit-message-form :is-request-pending="isUpdateRequestPending" :is-request-failed="isUpdateRequestFailed" :item="item" @submit="update" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditMessageForm from './_CreateOrEdit';
import Loading from '@/components/common/Loading';
import Button from './../common/Button';

export default {
  components: {
    'p-edit-message-form': CreateOrEditMessageForm,
    'p-loading': Loading,
    'p-button': Button
  },
  computed: {
    ...mapState({
      item: s => s.messages.item,
      isGetRequestPending: s => s.messages.isGetRequestPending,
      isUpdateRequestPending: s => s.messages.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.messages.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('messages/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('messages/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Message was updated.`
        });
        this.$router.push({ path: `/messages/` });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    },
    async confirmDelete() {
      const { id, name } = this.item;

      const confirmResult = await this.$confirm({
        title: 'Delete message?',
        message: `Are you sure you want to delete message '${name}'?\n\nThis action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();
      try {
        await this.$store.dispatch('messages/delete', id);

        this.$toast.success({
          title: 'Message deleted',
          message: `Message '${name}' (${id}) was successfully deleted.`
        });
        this.$router.push({ path: `/messages` });
      } catch (e) {
        this.$toast.error({
          title: 'Failed to delete message',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-message {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);

    button {
      margin-left: 1rem;
    }
  }
}
</style>
